module.exports = __webpack_public_path__ + "images/charity2.ca2f761d.svg";